import { string, func, object, shape, any } from 'prop-types';

const funcReq = func.isRequired;
export const intlShape = shape({
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func,

  formatDate: funcReq,
  formatTime: funcReq,
  formatRelativeTime: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq,

  formatters: object,
});
